<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  style="width:15%"
                  clearable
                  placeholder="请输入筛选姓名"
                  size="small"
                  v-model="search.aid_user_name"
                ></el-input>
                <el-select
                  v-model="search.project_id"
                  placeholder="请选择项目"
                  size="small"
                  clearable
                  @change="getReportList"
                >
                  <el-option
                    :label="item.project_name"
                    :value="item.project_id"
                    v-for="item in projectList"
                    :key="item.project_id"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="search.report_id"
                  :placeholder="search.project_id > 0?'请选择阶段':'请先选择项目'"
                  size="small"
                  :disabled="!(search.project_id > 0)"
                  style="width:12%"
                  clearable
                >
                  <el-option
                    v-for="(item,index) in reportList"
                    :key="index"
                    :label="item.report_name"
                    :value="item.id"
                  ></el-option>
                </el-select>

                <el-select
                  v-model="search.eye_disease"
                  placeholder="请选择眼疾"
                  size="small"
                  style="width:10%"
                  clearable
                >
                  <el-option
                    v-for="(item,index) in eyeDisease"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>

                <el-select
                  v-model="search.status_type"
                  placeholder="请选择状态"
                  size="small"
                  style="width:10%"
                  clearable
                >
                  <el-option :value="1" label="已提交"></el-option>
                  <el-option :value="2" label="未提交"></el-option>
                  <el-option :value="3" label="审核通过"></el-option>
                  <el-option :value="4" label="审核不通过"></el-option>
                </el-select>

                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="$refs.tables.handleSearch()"
                >搜索</el-button>
              </el-card>

              <WtDataTable
                ref="tables"
                :search="search"
                :listUrl="$db.config.com_project.apply.list"
                :delUrl="$db.config.com_project.apply.delete"
              >
                <div slot="buttons">
                  <el-button
                    size="small"
                    style="margin:10px 0px;"
                    type="primary"
                    icon="el-icon-sold-out"
                    @click="imports"
                  >导入</el-button>
                </div>
                <template slot="columns">
                  <el-table-column
                    type="selection"
                    width="55"
                    align="center"
                    :selectable="disabledCheck"
                  ></el-table-column>

                  <el-table-column label="姓名" prop="aid_user_name" min-width="80" align="center">
                    <template slot-scope="scope">
                      <a href="JavaScript:;" @click="look(scope.row.id)">{{scope.row.aid_user_name}}</a>
                    </template>
                  </el-table-column>

                  <el-table-column label="身份证" prop="card_no" align="center" min-width="150"></el-table-column>

                  <el-table-column label="眼疾" prop="eye_disease_text" align="center" min-width="70"></el-table-column>

                  <el-table-column label="项目名称" prop="project_name" min-width="100" align="center"></el-table-column>

                  <el-table-column label="项目阶段" prop="report_name" min-width="100" align="center"></el-table-column>

                  <el-table-column label="入院时间" prop="access_time" min-width="80" align="center"></el-table-column>

                  <el-table-column
                    label="困难程度"
                    prop="poor_type_text"
                    min-width="100"
                    align="center"
                  ></el-table-column>

                  <el-table-column label="状态" prop="status_text" min-width="100" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status == 1">
                        <span v-if="scope.row.audit_result == 1">{{scope.row.audit_result_text}}</span>
                        <span v-else>{{scope.row.status_text}}</span>
                      </span>
                      <span v-else>
                        <span
                          v-if="scope.row.audit_result == 2"
                          style="color:red;text-decoration: underline; cursor: pointer;"
                        >
                          <el-popover
                            placement="top"
                            title="审核意见："
                            width="200"
                            trigger="click"
                            :content="scope.row.audit_opinion"
                          >
                            <span slot="reference">{{scope.row.audit_result_text}}</span>
                          </el-popover>
                        </span>
                        <span v-else>{{scope.row.status_text}}</span>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" prop="handle" min-width="170" align="center">
                    <template slot-scope="scope">
                      <el-button-group>
                        <!-- <el-button
                          @click="edit(scope.row.id)"
                          type="primary"
                          icon="el-icon-edit"
                          :disabled="!scope.row.ifoption"
                          size="mini"
                        >编辑</el-button> -->

                        <el-button
                          @click="del(scope.row.id,scope.row.project_id)"
                          type="danger"
                          icon="el-icon-delete"
                          :disabled="!scope.row.ifoption"
                          size="mini"
                        >删除</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>
            </div>
          </el-col>
        </el-row>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
          <span>删除后将无法恢复，确认删除吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onDel">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <foot-div></foot-div>
    </div>
    <info :id="id" v-model="ifopen" v-if="ifopen" :ifdisabled="ifdisabled" @success="success"></info>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import info from "./info";
import "@/components/Hospital/public/poster.less";
import Axios from "axios";
import myHead from "@/components/Hospital/public/head";
import centerHead from "@/components/Hospital/public/center_head";
import leftMenu from "@/components/Hospital/public/menu";
import footDiv from "@/components/Hospital/public/foot";
export default {
  name: "report",
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    info
  },
  data() {
    return {
      auditMsg: "",
      ifdisabled: true,
      project_id: null, //删除用的
      ifopen: false,
      disabled: true, // 禁用按钮
      search: { aid_user_name: null, status_type: null, report_id: null }, // 搜索条件
      projectList: [], // 项目列表
      reportList: [], //报告列表
      tableData: [], // 表格数据
      page_size: 15, // 每页条数
      total: 0, // 数据总条数
      currentPage: 1, // 当前页
      uploadImgUrl: "", // 上传到图片的地址
      uploadParms: { file_type: 2 }, //图片上传所需参数
      uploadImgParams: { other_pics: [] }, // 保存凭证的参数
      yearList: [], // 年份
      eyeDisease: [], // 眼疾
      dialogVisible: false, // 删除确认框
      id: null
    };
  },
  methods: {
    // 导入
    imports() {
      this.$router.push({ name: "comProjectExports" });
    },

    // 编辑
    edit(id) {
      this.id = id;
      this.ifopen = true;
      this.ifdisabled = false;
    },

    // 查看
    look(id) {
      this.id = id;
      this.ifopen = true;
      this.ifdisabled = true;
    },

    //根据项目id获取阶段
    getReportList(id) {
      this.search.report_id = null;
      if (id > 0) {
        this.$db
          .post(this.$db.config.getStageListByProId, { id: id })
          .then(res => {
            if (res && res.code == 200) {
              this.reportList = res.data;
            }
          });
      }
    },

    success() {
      this.$refs.tables.reloadData();
    },

    //查看审核不通过的审核意见
    lookAudit(id) {
      this.$db
        .post(this.$db.config.lookComProApplyNoAudit, { id: id })
        .then(res => {
          if (res && res.code == 200) {
            this.auditMsg = res.data.audit_opinion;
          }
        });
    },

    handleSelectionChange(selection) {
      let arr = [];
      if (selection.length > 0) {
        this.disabled = false;
        selection.forEach(item => {
          arr.push(item.id);
        });
      } else {
        this.disabled = true;
      }
      this.uploadImgParams.ids = arr.join(",");
    },
    getSearchList() {
      // 获取简单列表
      this.$db.post(this.$db.config.getComProListForApply, {}).then(res => {
        if (res && res.code == 200) {
          this.projectList = res.data;
        }
      });
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100170,
          table: "pub_type_param"
        })
        .then(res => {
          this.eyeDisease = res.data;
        });
    },
    disabledCheck(row, index) {
      if (row.status == "已上报") {
        return false;
      } else {
        return true;
      }
    },
    del(id, pid) {
      this.id = id;
      this.project_id = pid;
      this.dialogVisible = true;
    },
    onDel(pid) {
      this.$db
        .post(this.$db.config.comProListApplyDelete, {
          ids: this.id,
          project_id: this.project_id
        })
        .then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.id = null;
            this.project_id = null;
            this.$refs.tables.reloadData();
            this.dialogVisible = false;
          }
        });
    }
  },
  created() {
    this.getSearchList();
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    // max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/apply/list.vue